import { useTranslation } from 'react-i18next';

export function WhySection() {
  const { t } = useTranslation();

  const reasons = [
    t('about.why.reasons.0'),
    t('about.why.reasons.1'),
    t('about.why.reasons.2'),
    t('about.why.reasons.3'),
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
              <i className="ri-question-line text-4xl text-yellow-400"></i>
            </div>
          </div>
          
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-12">
            {t('about.why.title')}
          </h2>

          <div className="space-y-6 mb-12">
            {reasons.map((reason, index) => (
              <div 
                key={index}
                className="flex items-start space-x-4 bg-gray-800 rounded-xl p-6 border border-gray-700 text-left hover:border-yellow-400 transition-ball duration-300"
              >
                <div className="flex-shrink-0 mt-1">
                  <i className="ri-arrow-right-circle-fill text-2xl text-yellow-400"></i>
                </div>
                <p className="text-gray-300 text-lg leading-relaxed">{reason}</p>
              </div>
            ))}
          </div>

          <p className="text-white text-xl sm:text-2xl font-semibold leading-relaxed">
            {t('about.why.conclusion')}
          </p>
        </div>
      </div>
    </section>
  );
}
